export const ADMIN = '/phia/administrator';
export const EDITOR = '/phia/editor';
export const VIEWER = '/phia/viewer';
export const VIEWER_VIP = '/phia/viewer_vip';
export const VALIDATOR = '/phia/validator';
export const DOWNLOAD = '/phia/download';